import { __ } from 'i18n-for-browser';
import {groupIcons} from "../assets/assets";
import LoanBankOverview from "../assets/img/icons/bank.png";

import gameStateInputFromActions from '../actions/gameStateInput';
const { updateMyState } = gameStateInputFromActions;

function getCountryIcon(otherCountry) {
  let icon;
  switch (__(otherCountry).toLowerCase()) {
    case __("Rood").toLowerCase():
    case "rood":
      icon = groupIcons['rood'];
      break;
    case __("Oranje").toLowerCase():
    case "oranje":
      icon = groupIcons['oranje'];
      break;
    case __("Geel").toLowerCase():
    case "geel":
      icon = groupIcons['geel'];
      break;
    case __("Groen").toLowerCase():
    case "groen":
      icon = groupIcons['groen'];
      break;
    case __("Blauw").toLowerCase():
    case "blauw":
      icon = groupIcons['blauw'];
      break;
    case __("Paars").toLowerCase():
    case "paars":
      icon = groupIcons['paars'];
      break;
    default:
      icon = groupIcons[__(otherCountry).toLowerCase()];
      break;
  }
  return icon;
}

function getSavedGlobas(gameState, debitCredit = []){
  let prevSavings = 0;
  const prevRoundLastGamestate = gameState.prevRound.GameStates[gameState.prevRound.GameStates.length - 1];
  if (prevRoundLastGamestate && prevRoundLastGamestate.OneTimeEffect && Array.isArray(prevRoundLastGamestate.OneTimeEffect.debitCredit)) {
    prevSavings = prevRoundLastGamestate.OneTimeEffect.debitCredit
      .filter(dc => dc.key==='stortenSpaargeld')
      .reduce((acc, dc)=> acc-dc.amount, 0);
  }

  let savingsThisround = 0;
  if(debitCredit['stortenSpaargeld'] && debitCredit['stortenSpaargeld'].confirmed) {
    savingsThisround = debitCredit['stortenSpaargeld'].amount;
  }

  let withdrawalThisround = 0;
  if(debitCredit['opnemenSpaargeld'] && debitCredit['opnemenSpaargeld'].confirmed) {
    withdrawalThisround = debitCredit['opnemenSpaargeld'].amount;
  }

  return prevSavings + savingsThisround - withdrawalThisround;
}

function getRemainingOwnedGlobas(globas, gameState){
  const reducingKeys = ['lenenAanland', 'schenkAanLand', 'stortenSpaargeld'];
  let globasRemaining = gameState.Rounds.reduce(
    (total, current) => {
      const debCred = current.debitCredit;
      if(debCred === undefined){
        return total;
      }

      let collector = total;

      //remove globa's for all rounds
      reducingKeys.forEach(function(key){
        if(key in debCred){
          collector -= debCred[key].amount;
        }
      });

      return collector;
    }, globas
  );
  return globasRemaining;
}

function getMaxSpendable(saved, globas, maximum){
  const maxRemaining = maximum - saved;
  if(maxRemaining <= 0){
    return 0;
  }

  if(maxRemaining > globas){
    return globas;
  }

  return maxRemaining
}

function getSavingsInterest(gameState, currentCredit, prevSaved = 0, interest = 1, removeWithdrawn = false){
  let amountSaved = prevSaved;

  if(currentCredit.stortenSpaargeld !== undefined){
    if(!currentCredit.stortenSpaargeld.confirmed){
      amountSaved += currentCredit.stortenSpaargeld.amount;
    }
    if(removeWithdrawn && currentCredit.opnemenSpaargeld && currentCredit.opnemenSpaargeld.amount) {
      amountSaved -= currentCredit.opnemenSpaargeld.amount;
    }
  }

  return Math.floor(amountSaved * interest);
}

function getOverview(gameStateInput, dispatch = false, state = false, bankNotificationsState = false, isHistory = false) {
  const {states, myState} = gameStateInput;
  const country = myState.theme;

  //Geleend, gekregen of opgenomen;
  const plusKeys = isHistory ? ['lenenVanLand', 'lenenVanBank', 'opnemenSpaargeld'] : ['lenenVanLand', 'lenenVanBank', 'opnemenSpaargeld', 'lenenVanLandNotConfirmed'];
  const plusResult = getKeys(dispatch, gameStateInput, plusKeys, ['lenenVanLand', 'lenenVanLandNotConfirmed']);
  let plus = plusResult.items;
  let plusTotal = plusResult.amount;

  const plusCorrectionIndex = plus.findIndex((c) => c.key === 'lenenVanLandNotConfirmed' && c.pending !== true);
  if(plusCorrectionIndex > -1) {
    plusTotal -= plus[plusCorrectionIndex].points;
    plus.splice(plusCorrectionIndex, 1);
  }

  //Check for gifts
  let gift = (Object.keys(states).length === 0 && states.constructor === Object ? undefined :
    Object.keys(states[gameStateInput.currentRound]).map((current) => {
      //Escape if it's my state.
      if(current === gameStateInput.groupId.toString()) return false;

      //Check only for current round
      const extDbCr = states[gameStateInput.currentRound][current].debitCredit;
      const extCountry = states[gameStateInput.currentRound][current].theme;
      if(extDbCr === undefined || (Object.keys(extDbCr).length === 0 && extDbCr.constructor === Object)){
        return false
      }

      //Check for gifts by other countries
      if(!('schenkAanLand' in extDbCr)) return false;


      //check if item is confirmed by user
      if(extDbCr['schenkAanLand'].confirmed !== true) {
        return false;
      }

      //If the country the gift is gifted to is my country...
      if(extDbCr['schenkAanLand'].otherCountry === country) {
        //Add cummulative money earned
        plusTotal += extDbCr['schenkAanLand'].amount;
        return {
          title: `${__('schenkVanLand')} ${__(extCountry).toLowerCase()}`,
          pending: false,
          points: extDbCr['schenkAanLand'].amount,
          icon: getCountryIcon(extCountry),
        }
      } else {
        return false;
      }
    }).filter(Boolean)
  );

  // Concat gitfts to others when there are any.
  if(gift !== undefined && gift.length > 0){
    plus = plus.concat(gift);
  }

  const plusReadMap = plus.map((c) => {return c.pending});

  //Uitgeleend, geschonken of gespaard;
  const minusKeys = isHistory ? ['lenenAanLand', 'schenkAanLand', 'stortenSpaargeld'] : ['lenenAanLand', 'schenkAanLand', 'stortenSpaargeld', 'lenenAanLandNotConfirmed'];
  const minusResult = getKeys(dispatch, gameStateInput, minusKeys, ['lenenAanLand', 'lenenAanLandNotConfirmed']);
  const minus = minusResult.items;
  let minusTotal = minusResult.amount;
  const minusReadMap = minus.map((c) => {return c.pending});


  const minusCorrectionIndex = minus.findIndex((c) => c.key === 'lenenAanLandNotConfirmed' && c.pending !== true);
  if(minusCorrectionIndex > -1) {
    minusTotal -= minus[minusCorrectionIndex].points;
    minus.splice(minusCorrectionIndex, 1);
  }

  //Betaalde aflossingen en rentes;
  const paidKeys = ['lenenVanBank', 'lenenVanLand'];
  const paidInterestRes = getInterest(gameStateInput, paidKeys);
  let paidInterest = paidInterestRes.items;
  let paidInterestTotal = paidInterestRes.amount;

  //Ontvangen aflossingen en rentes;
  const receivedKeys = ['stortenSpaargeld', 'lenenAanLand'];
  const receivedKeysNoAmount = [];//['stortenSpaargeld'];
  const receivedInterestRes = getInterest(gameStateInput, receivedKeys, receivedKeysNoAmount);
  let receivedInterest = receivedInterestRes.items;
  let receivedInterestTotal = receivedInterestRes.amount;

  const toDisplay = [{
    title: 'mhgvtoverzichtsparenlenen',
    items: [{
      title: __('sim_geleend_gekregen_of_opgenomen'),
      extraInfo: '(+)',
      points: plusTotal,
      items: plus,
      pending: plusReadMap.includes(true),
      readMap: plusReadMap,
      keys: plusKeys,
    },{
      title: __('sim_uitgeleend_geschonken_of_gespaard'),
      extraInfo: '(-)',
      points: minusTotal,
      items: minus,
      pending: minusReadMap.includes(true),
      readMap: minusReadMap,
      keys: minusKeys,
    },{
      title: __('sim_betaalde_aflossingen_en_rentes'),
      extraInfo: '(-)',
      items: paidInterest,
      points: paidInterestTotal,
    },{
      title: __('sim_ontvangen_aflossingen_en_rentes'),
      extraInfo: '(+)',
      points: receivedInterestTotal,
      items: receivedInterest,
    }]
  }];

  return toDisplay;
}

function getKeys(dispatch, gameStateInput, keys, confirmationKeys) {
  const {states, myState} = gameStateInput;
  let {debitCredit} = myState;
  if(!debitCredit) debitCredit = {};
  const country = myState.theme;

  const rainbow = {
    lenenVanLand: 'lenenAanLand',
    lenenAanLand: 'lenenVanLand',
    lenenVanLandNotConfirmed: 'lenenAanLandNotConfirmed',
    lenenAanLandNotConfirmed: 'lenenVanLandNotConfirmed',
  };

  let accumulative = 0;
  let results = Object.keys(debitCredit).map((targetKey, index) => {
    //Check if object's key is applicable to this category;
    if(keys.includes(targetKey)){
      const dbCr = debitCredit[targetKey];
      if(dbCr.amount === undefined || dbCr.amount === 0) return false;

      //Check if confirmed self.
      if(dbCr.confirmed !== true) {
        return false;
      }

      //Defaultvalue for pending is false: a transaction doesn't require another player's confimation
      let isPending = false;
      //Check if item requires confirmation
      if(confirmationKeys.includes(targetKey)) {
        //Check if the user has defined the country to close a deal with
        if(dbCr.otherCountry === undefined) return false;

        //Check if states are set, if yes, find values...
        isPending = (Object.keys(states).length === 0 && states.constructor === Object ? undefined :
          Object.keys(states[gameStateInput.currentRound]).find((current) => {
            //Escape if it's my round.
            if(current === gameStateInput.groupId.toString()) return false;

            //Working object to compare data with.
            const extDbCr = states[gameStateInput.currentRound][current].debitCredit;

            //Find the corresponding key from the enternal entity,
            //if it doesn't exist, stop.
            if(!(rainbow[targetKey] in extDbCr)) return false;

            //Get data from object to compare.
            const rec = extDbCr[rainbow[targetKey]];

            //Check data and return if they match.

            if(rec.otherCountry === country && rec.amount === dbCr.amount && rec.interest === dbCr.interest){
              //Check if other user confirmed input
              if(rec.confirmed !== true) {
                return false;
              }

              if(targetKey === 'lenenVanLandNotConfirmed') {
                if(extDbCr.globas < rec.amount) {
                  return false;
                } else {
                  if(dispatch !== false && !('lenenVanLand' in debitCredit)) {
                    dispatch(updateMyState(
                      {
                        debitCredit:{...debitCredit, lenenVanLand: debitCredit.lenenVanLandNotConfirmed}
                      }
                    ))
                  }
                }
              }
              if (targetKey === 'lenenAanLandNotConfirmed') {
                if(dispatch !== false && 'lenenVanLand' in extDbCr && !('lenenAanLand' in debitCredit)) {
                  dispatch(updateMyState(
                    {
                      debitCredit:{...debitCredit, lenenAanLand: debitCredit.lenenAanLandNotConfirmed}
                    }
                  ))
                }
              }

              return true;
            }
            return false;
          })
        );
        //Make result human readable.
        isPending = isPending === undefined ? true : false;
      }

      //Select icon for transaction
      let icon = LoanBankOverview;
      if(confirmationKeys.includes(targetKey) || targetKey === 'schenkAanLand') {
        icon = getCountryIcon(dbCr.otherCountry);
      }

      //Add cummulative money earned
      accumulative += (isPending ? 0 : dbCr.amount);

      let title;
      switch (targetKey) {
        case 'lenenAanLandNotConfirmed':
          title = 'leningAanLand';
          break;
        case 'lenenVanLandNotConfirmed':
          title = 'leningVanLand';
          break;
        default:
          title = targetKey;
          break;
      }

      return {
        title: `${__(title)} ${dbCr.otherCountry !== undefined ? __(dbCr.otherCountry).toLowerCase() : ""}`,
        pending: isPending,
        key: targetKey,
        points: dbCr.amount,
        icon: icon,
      }
    } else {
      return false;
    }
  }).filter(Boolean);
  return {
    items: results,
    amount: accumulative
  };
}

function getInterest(gameStateInput, keys, noAmountKeys = []){
  const {states} = gameStateInput;

  const myGroupId = gameStateInput.groupId;
  const currentRound = gameStateInput.currentRound;
  let accumulative = 0;

  let savingsInterest = 0;
  if(gameStateInput.myState.oneTimeEffect.debitCredit) {
    savingsInterest = Object.values(gameStateInput.myState.oneTimeEffect.debitCredit)
      .filter(o => o.key === "stortenSpaargeld")
      .reduce((accumilator, entry) => accumilator + -entry.interest, 0);
  }
  let depositFlag = 0;
  let results = Object.keys(states).reduce((array, current, index) => {
    //Only check for previous two rounds
    if(index < currentRound - 2) {
      return array;
    }
    if(index > currentRound - 1) {
      return array;
    }
    let values = Object.keys(states[current]).reduce((arr, key) => {
      //If the current group isn't mine, stop;
      if(key !== myGroupId.toString()) return arr;

      let items = [];
      //Check if key exists in object
      if(states[current].hasOwnProperty(key)){
        //Store as working object.
        const dbCr = states[current][key].debitCredit;
        for(let key in dbCr){
          if(keys.includes(key)){
            const curDbCr = dbCr[key];
            //check if item is confirmed by user
            if(curDbCr.confirmed !== true) {
              continue;
            }

            //calculate how many rounds it has been since the deal was made
            const passedRounds = currentRound - parseInt(current, 10);

            let interest = 0;
            let amount = 0;

            //Check what calculation has to be made based on amount of rounds passed
            if(key === 'stortenSpaargeld') {
              if(depositFlag === 0) {
                amount = savingsInterest;
                accumulative += interest + amount;
                depositFlag = 1;
              }
            } else if((currentRound === 4 && passedRounds === 1)){
              amount = curDbCr.interest;
              if(!noAmountKeys.includes(key)){
                amount += curDbCr.amount;
              }
              accumulative += interest + amount;
            } else if(passedRounds > 1){
              //Two rounds ago
              amount = curDbCr.interest / 2;
              if(!noAmountKeys.includes(key)){
                amount += curDbCr.amount / 2;
              }
              accumulative += Math.floor(amount + interest);
            } else {
              //Happened in previous round
              amount = curDbCr.interest / 2;
              if(!noAmountKeys.includes(key)){
                amount += curDbCr.amount / 2;
              }
              amount = Math.ceil(amount);
              accumulative += Math.ceil(amount + interest);
            }

            //Select icon for transaction
            let icon = LoanBankOverview;
            if(curDbCr.otherCountry !== undefined) {
              icon = groupIcons[__(curDbCr.otherCountry).toLowerCase()]
            }

            const entryTitleRainbow = {
              "lenenVanLand": "leningVanLand",
              "lenenAanLand": "leningAanLand"
            };
            let keyForEntryTitle = entryTitleRainbow[key] || key;

            let entryTitle = `${__('sim_aflossing')} ${__(keyForEntryTitle).replace(/^\w/, c => c.toLowerCase())} ${curDbCr.otherCountry !== undefined ? __(curDbCr.otherCountry) : ""}`;

            if(interest > 0 || amount > 0) {
              items.push({
                title: key === 'stortenSpaargeld' ? __('sim_rente_op_spaargeld') : entryTitle,
                pending: false,
                points: Math.floor(interest + amount),
                icon: icon,
              })
            }
          }
        }
      }
      return items;
    }, []);
    return array.concat(...values);
  }, []);
  return {
    items: results,
    amount: accumulative
  }
}

function getUnreadGifts(gameStateInput) {
  let unreadGifts = false;
  if(gameStateInput) {
    const {states} = gameStateInput;
    const index = Object.keys(states).length - 2;
    const inputs = states[index];
    if(inputs) {
      const entries = Object.entries(inputs);
      const {groupId} = gameStateInput;
      unreadGifts = entries.map((c) => {
        if(c[0] === groupId || c[0] === groupId.toString()) return false;
        const gsInput = c[1];
        const dbCrArr = gsInput.debitCredit;
        if( !dbCrArr.hasOwnProperty('schenkAanLand') ) return false;
        if(dbCrArr['schenkAanLand'].otherCountry === gameStateInput.myState.theme && dbCrArr['schenkAanLand'].confirmed) {
          return {...dbCrArr['schenkAanLand'], fromCountry: gsInput.theme};
        }
        return false;
      }).filter(Boolean);
    }
  }
  if(unreadGifts !== false) {
    let data = sessionStorage.getItem('debitCreditGifts');
    data = JSON.parse(data);
    if(!data || !(gameStateInput.myState.roundId in data)) {
      data = {};
      if(unreadGifts && unreadGifts.length > 0) {
        data[gameStateInput.myState.roundId] = unreadGifts;
        sessionStorage.setItem('debitCreditGifts', JSON.stringify(data));
      }
      return false;
    } else {
      let round = data[gameStateInput.myState.roundId];
      //Compare new and old
      const changes = round.map(c => {
        const {amount, fromCountry} = c;
        const match = unreadGifts.find(d => {
          return d.amount === amount && d.fromCountry === fromCountry
        });
        if(match) {
          return false;
        }
        return c;
      }).filter(Boolean);
      round = [...round, ...changes];
      data[gameStateInput.myState.roundId] = round;
      sessionStorage.setItem('debitCreditGifts', JSON.stringify(data));
    }
    return data[gameStateInput.myState.roundId].some(c => c.unread === true);
  }
  return false;
}

function setGiftsRead(gameStateInput) {
  let data = sessionStorage.getItem('debitCreditGifts');
  data = JSON.parse(data);
  if (data && gameStateInput.myState.roundId in data) {
    let round = data[gameStateInput.myState.roundId];
    round = round.map(r => {
      r.unread = false;
      return r;
    });
    data[gameStateInput.myState.roundId] = round;
    sessionStorage.setItem('debitCreditGifts', JSON.stringify(data));
  }
}

export {
  setGiftsRead,
  getMaxSpendable,
  getSavedGlobas,
  getSavingsInterest,
  getRemainingOwnedGlobas,
  getOverview,
  getUnreadGifts,
  getCountryIcon
}



// WEBPACK FOOTER //
// ./src/helpers/bankHelper.js